import type { FunctionalComponent as FC } from 'preact';

import type { AttachedFile } from '../../types/files';

import { FileItem } from '../FileItem';

interface Props {
  className?: string;
  itemClassName?: string;
  files?: AttachedFile[];
}

export const FilesList: FC<Props> = ({ className, itemClassName, files }) => {
  if (!files || !files.length) {
    return null;
  }

  const list = files.map((file) => <FileItem className={itemClassName} {...file} />);

  return <div className={className}>{list}</div>;
};
